<template>
  <el-row :gutter="24">
    <!--    <el-col :span="24">-->
    <!--      <p>-->
    <!--        Thời gian bay yêu cầu:-->
    <!--        {{  }}-->
    <!--      </p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Thời gian bay yêu cầu"
      :value="getDateTimeLabel(userRoute.flightTimeEstimate)"
    ></hc-maybay-user-route-extend-info-item>

    <!--    <el-col :span="24">-->
    <!--      <p>Giới tính: {{ getGenderLabel(userRoute.gender) || "-" }}</p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Giới tính"
      :value="getGenderLabel(userRoute.gender)"
    ></hc-maybay-user-route-extend-info-item>

    <!--    <el-col :span="24">-->
    <!--      <p>Ngày sinh: {{ getDateLabel(userRoute.birthday) || "-" }}</p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Ngày sinh"
      :value="getDateLabel(userRoute.birthday)"
    ></hc-maybay-user-route-extend-info-item>

    <!--    <el-col :span="24">-->
    <!--      <p>Hộ chiếu/CMTND: {{ userRoute.identityNumber || "-" }}</p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Hộ chiếu/CMTND"
      :value="userRoute.identityNumber"
    ></hc-maybay-user-route-extend-info-item>

    <!--    <el-col :span="24">-->
    <!--      <p>Số điện thoại: {{ userRoute.isdn || "-" }}</p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Số điện thoại"
      :value="userRoute.isdn"
    ></hc-maybay-user-route-extend-info-item>

    <!--    <el-col :span="24">-->
    <!--      <p>Email: {{ userRoute.email || "-" }}</p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Email"
      :value="userRoute.email"
    ></hc-maybay-user-route-extend-info-item>

    <!--    <el-col :span="24">-->
    <!--      <p>Thẻ bông sen vàng: {{ userRoute.bsvNumber || "-" }}</p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Thẻ bông sen vàng"
      :value="userRoute.bsvNumber"
    ></hc-maybay-user-route-extend-info-item>

    <!--    <el-col :span="24">-->
    <!--      <p>-->
    <!--        Chức danh: {{ userRoute.positionName || "-" }} - -->
    <!--        {{ userRoute.deptName || "-" }}-->
    <!--      </p>-->
    <!--    </el-col>-->

    <hc-maybay-user-route-extend-info-item
      fieldTitle="Chức danh"
      :value="`${userRoute.positionName || '-'} - ${userRoute.deptName || '-'}`"
    ></hc-maybay-user-route-extend-info-item>
  </el-row>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import dateFormatter from "../../../filters/dateFormatter";
import BreakWordSpan from "../ketluan/break-word-span";
import constants from "../../../constants";
import HcMaybayUserRouteExtendInfoItem from "./hc-maybay-user-route-extend-info-item";

export default {
  name: "hc-maybay-user-route-extend-info",
  mixins: [handleRequestErrorMixin],
  filters: { dateFormatter },
  components: { HcMaybayUserRouteExtendInfoItem, BreakWordSpan },
  props: ["userRoute"],

  data() {
    return {};
  },

  watch: {},

  created() {},

  methods: {
    getDateTimeLabel(value) {
      return dateFormatter(value, {
        dateFormat: constants.DEFAULT_DATETIME_FORMAT,
        nullValue: "-"
      });
    },

    getDateLabel(value) {
      return dateFormatter(value, {
        dateFormat: constants.DEFAULT_DATE_FORMAT,
        nullValue: "-"
      });
    },

    getGenderLabel(gender) {
      return hanhChinhUtils.getHcGenderLabel(gender);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-user-route-extend-info.vue